const SaleOrigin = () => import(/* webpackChunkName: "saleOrigin" */ './SaleOrigin.vue')

const index = {
  path: 'sale/origin',
  name: 'Sale Origin',
  component: SaleOrigin,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
